import {
    REPORT_GET_ALL,
    REPORT_DELETE_REPORTED_ITEM,
} from "../actions/reporting";

import {
    API_BASE_URL,
    REPORT_GET_ALL_URL,
    REPORT_DELETE_REPORTED_ITEM_URL,
} from "../variables";

import axios from "axios";

const state = {};
const mutations = {};
const getters = {};
const actions = {
    [REPORT_DELETE_REPORTED_ITEM]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + REPORT_DELETE_REPORTED_ITEM_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [REPORT_GET_ALL]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + REPORT_GET_ALL_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
};


export default {
    mutations,
    actions,
    getters,
    state
};